import React from "react";

import {
  Divider,
  Placeholder,
  PlaceholderHeader,
  PlaceholderLine,
  PlaceholderParagraph,
} from "semantic-ui-react";

const MeetingCardPlaceholder = () => {
  return (
    <React.Fragment>
      <Divider style={{ margin: "0" }} />

      <Placeholder style={{ margin: "1.5em" }}>
        <PlaceholderParagraph>
          <PlaceholderLine />
          <PlaceholderLine length="short" />
        </PlaceholderParagraph>

        <PlaceholderParagraph>
          <PlaceholderLine />
        </PlaceholderParagraph>

        <PlaceholderParagraph>
          <PlaceholderLine length="very short" />
        </PlaceholderParagraph>

        <PlaceholderHeader image />
      </Placeholder>
    </React.Fragment>
  );
};

export default MeetingCardPlaceholder;
